import _mountView from 'rlink-router/actions/_mountView';
import _loadView from 'rlink-router/actions/_loadView';
import closeAllModals from 'rlink-router/actions/closeAllModals';
import hideTooltip from 'rlink-tooltips/actions/hideTooltip';
import getCurrentLocale from 'rlink-router/getCurrentLocale';
import getCurrentRegion from 'rlink-router/getCurrentRegion';
const CONTENT_AUTHORING_LOCALE = 'en';
/**
 * Load and navigate to the given view and params.
 *
 * @param  {BuildContext} buildContext          The current buildContext.
 * @param  {string}  options.view               The name of a view function.
 * @param  {object}  options.params             View params.
 * @param  {string}  options.transition         The name of a loading transition (optional).
 * @param  {string}  options.returnTransition   The name of a transition to use when navigating back into this view (usually the opposite of the forward transition - defaults to the same value as transition if transition is given).
 * @param  {Boolean} options.replaceNavState Should the current history item be replaced rather than a new one added? (default: false)
 * @return {Thunk}
 */
export default function navTo (buildContext, {
    view,
    params = {},
    scrollPosition = {top: 0, left: 0},
    returnScrollPosition = typeof window !== 'undefined' && {top: window.scrollY, left: window.scrollX},
    transition = null,
    returnTransition = null,
    replaceNavState = false,
    keepScrollPosition = false,
  }) {
  if (keepScrollPosition) {
    scrollPosition = returnScrollPosition;
  }
  if (returnTransition === null && transition !== null) {
    returnTransition = transition;
  }

  return (dispatch, getState, {navigationEngine}) => {
    let routing = getState().routing;
    let currentLocale = getCurrentLocale(routing);
    let currentRegion = getCurrentRegion(routing);
    if (!params.locale) {
      params.locale = currentLocale;
    }
    if (!params.region) {
      params.region = currentRegion;
    }
    return Promise.all([
      dispatch(_loadView(buildContext, view, params)),
      dispatch(hideTooltip()),
      dispatch(closeAllModals()),
    ]).then(([content, _]) => {
      let navState = {
        view, params,
        transition, returnTransition,
        scrollPosition: returnScrollPosition,
      };
      if (replaceNavState) {
        navigationEngine.replaceCurrentNavState(navState);
      } else {
        navigationEngine.addNewNavState(navState);
      }
      return dispatch(_mountView({
        view, params,
        transition,
        content,
        scrollPosition,
      }));
    }, err => {
      if (err && err.missingContent
          && params.locale !== CONTENT_AUTHORING_LOCALE) {
        console.warn(`Falling back to authoring locale due to missing content at ${err.missingContent}`);
        return dispatch(navTo(buildContext, {
          view,
          params: {...params, locale: CONTENT_AUTHORING_LOCALE},
          scrollPosition,
          returnScrollPosition,
          transition,
          returnTransition,
          replaceNavState,
        }));
      } else {
        return Promise.reject(err);
      }
    });
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/navTo.js